export default __webpack_public_path__ + "static/media/AdalgisaLovelace.47035de2.png";